import type { SalesforcePaymentsConfig } from '../types/config';
import type { PaymentRequest } from '../types/paymentRequest';
import { PaymentMode } from '../types/paymentMethodSet';
import type { PaymentMethodSet } from '../types/paymentMethodSet';
import { Component } from './component';
import type SfpContext from '../sfp-context';
import type { MetadataReader } from '../util/metadata-reader';

export abstract class PaymentSheet extends Component {
  constructor(
    context: SfpContext,
    metadataReader: MetadataReader,
    paymentMethodSet: PaymentMethodSet,
    config: SalesforcePaymentsConfig,
    paymentRequest: PaymentRequest,
    elementOrSelectorToMountTo: string | HTMLElement
  ) {
    super(
      context,
      PaymentMode.MULTISTEP,
      metadataReader,
      paymentMethodSet,
      config,
      paymentRequest,
      elementOrSelectorToMountTo
    );
  }

  public async initialize(): Promise<void> {
    await super.initialize();

    if (this.selectedPaymentMethod) {
      this.firePaymentMethodEvent('sfp:paymentmethodselected', this.selectedPaymentMethod, this.paymentMode);
    }
  }

  /**
   * Returns if the input for the currently selected payment method is in an error state.
   * @returns {boolean} - <code>true</code> if it is in an error state, or <code>false</code> if not.
   * @public
   */
  hasError(): boolean {
    return this.selectedPaymentMethod.hasError();
  }
}
